import React from 'react';
import { Link } from "react-router-dom";
import "./VideoGrid.css";
import firebase from '../Firebase';

class Video extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      var uid = firebase.auth().currentUser.uid;
      this.setState({ userId: uid });
    });
  }

  deleteVideo = () => {
    const db = firebase.firestore();
    var uid = this.state.userId;
    
    var storageRef = firebase.storage().ref();
    var folderRef = storageRef.child(uid).child(this.props.vid);
    folderRef.child('video').delete();
    folderRef.child('video_thumbnail.png').delete();

    var dbRecord = db.collection("users").doc(uid).collection("videos").doc(this.props.vid);
    dbRecord.delete();
  }

  videoThumb = () => {
    if(this.props.viddata.thumbnailUrl){
      return <img src={this.props.viddata.thumbnailUrl} />
    }else{
      return <img src="/video-placeholder.png" />
    }
  }

  render() {
    return (
      <div className="video">
        <h1>{this.props.viddata.videoName}</h1>
        <a href={"/my-videos-edit/" + this.props.vid}>
          {this.videoThumb()}
        </a>
        <p>
          <progress value={this.props.viddata.uploadProgress / 100} />
          {this.props.viddata.uploadProgress}
          <br/>
          <Link to={"/my-videos-edit/" + this.props.vid}>Edit</Link>
          <Link to={"/my-videos-export/" + this.props.vid}>Export</Link>
          <button onClick={this.deleteVideo} >Delete</button>
        </p>
      </div>
    )
  }
}

export default Video;